import { LogoMark } from "./Logo";

const ROWS = [
  ["Legal Entity", "DEFCOIN LTD.", false],
  ["NCAGE", "01GUU", false],
  ["UEI", "FJNKCGJV1QQ6", false],
  ["UIC / VAT", "208073340 / BG208073340", false],
  ["SAM.GOV", "REGISTERED FOREIGN VENDOR", false],
  ["Entity Type", "FOREIGN / SMALL BUSINESS / EU-BASED", false],
  ["Location", "SOFIA, BULGARIA (EU / NATO EASTERN FLANK)", false],
  ["NAICS", "541614 (PRIMARY) · 423110 · 423120 · 423430 · 423910 · 424710 · 424720", false],
  ["Divisions", "IT / DUAL-USE / SUBCONTRACTING / FUEL / INFRASTRUCTURE / LOGISTICS", false],
  ["Contact", "contracts@def-coin.com", false],
  ["Phone", "+359 87 606 5815", false],
  ["RFQ Response", "24H — OCONUS TEMPO", false],
];

export default function KoView() {
  return (
    <aside className="border border-slate-800 bg-[#0D0F12]" data-testid="ko-view-panel">
      <div className="px-4 sm:px-5 py-3 border-b border-slate-800 flex items-center justify-between gap-3">
        <span className="flex items-center gap-2.5 shrink-0">
          <LogoMark className="h-6 w-6" id="ko-logo" />
          <span className="font-mono text-[10px] tracking-[0.25em] sm:tracking-[0.3em] uppercase text-slate-400 whitespace-nowrap">
            KO Quick-Ref
          </span>
        </span>
        <span className="font-mono text-[10px] tracking-[0.2em] sm:tracking-[0.25em] uppercase text-amber-600 text-right">
          EU / NATO Eastern Flank
        </span>
      </div>
      {ROWS.map(([label, value, pending]) => (
        <div
          key={label}
          className="grid grid-cols-[92px_1fr] sm:flex sm:items-baseline sm:justify-between gap-3 sm:gap-4 px-4 sm:px-5 py-2.5 border-b border-slate-800/60 last:border-b-0"
          data-testid={`ko-view-row-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
        >
          <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-slate-500 shrink-0 leading-[1.6]">
            {label}
          </span>
          <span
            className={`font-mono text-[11px] tracking-[0.06em] text-left sm:text-right break-words ${
              pending ? "text-amber-600" : "text-slate-300"
            }`}
          >
            {label === "Contact" ? (
              <a href={`mailto:${value}`} className="underline-offset-2 active:underline" data-testid="ko-view-email-link">{value}</a>
            ) : label === "Phone" ? (
              <a href={`tel:${value.replace(/\s/g, "")}`} className="underline-offset-2 active:underline" data-testid="ko-view-phone-link">{value}</a>
            ) : (
              value
            )}
          </span>
        </div>
      ))}
    </aside>
  );
}
